const ANALYTICS_ANALYSIS_OVERLAY_PARAM = 'AnalyticsAnalysisOverlay';
const ANALYTICS_ANALYSIS_OVERLAY_SHOW_VALUE = 'show';

export const hasAnalyticsAnalysisOverlayParam = () => {
    const url = new URL(window.location.href);
    const hashQueryStartIndex = url.hash.indexOf('?');

    if (url.searchParams.get(ANALYTICS_ANALYSIS_OVERLAY_PARAM) === ANALYTICS_ANALYSIS_OVERLAY_SHOW_VALUE) {
        return true;
    }

    if (hashQueryStartIndex === -1) {
        return false;
    }

    const hashSearchParams = new URLSearchParams(url.hash.slice(hashQueryStartIndex + 1));
    return hashSearchParams.get(ANALYTICS_ANALYSIS_OVERLAY_PARAM) === ANALYTICS_ANALYSIS_OVERLAY_SHOW_VALUE;
};

export const removeAnalyticsAnalysisOverlayParam = () => {
    const url = new URL(window.location.href);
    const hashQueryStartIndex = url.hash.indexOf('?');

    url.searchParams.delete(ANALYTICS_ANALYSIS_OVERLAY_PARAM);

    if (hashQueryStartIndex !== -1) {
        const hashPath = url.hash.slice(0, hashQueryStartIndex);
        const hashSearchParams = new URLSearchParams(url.hash.slice(hashQueryStartIndex + 1));
        hashSearchParams.delete(ANALYTICS_ANALYSIS_OVERLAY_PARAM);

        const hashSearch = hashSearchParams.toString();
        url.hash = `${hashPath}${hashSearch ? `?${hashSearch}` : ''}`;
    }

    window.history.replaceState(window.history.state, '', url);
};
